/* ============================================================
   Neovitale Pink October - catch the ribbon + discount popup
   Settings come from sections/pink-ribbon.liquid (#neo-ribbon-config).
   Flow: greeting popup (optional) -> ribbons pop up -> catch one -> discount popup
   Depends on: lottie-web, pink-ribbon-catcher.js
   ============================================================ */
(function () {
  'use strict';

  // Run only once per page. The theme editor reloads the section (and this script) on every
  // setting change; without this guard each reload would start another game on top of the old one.
  if (window.NeoPinkRibbon) { window.NeoPinkRibbon.init(); return; }

  var STORAGE_KEY = 'neoPinkRibbonCaught';
  var INTRO_KEY = 'neoPinkRibbonIntroSeen';
  var game = null;
  var introTimer = null;
  var decoAnims = {};
  var current = null; // open dialog { overlay, onClose, lastFocus }

  function $(id) { return document.getElementById(id); }

  function readConfig() {
    var el = $('neo-ribbon-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function isDesignMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* ---------- Memory: caught / greeting seen ---------- */
  function store(type) {
    try {
      if (type === 'forever') return window.localStorage;
      if (type === 'session') return window.sessionStorage;
    } catch (e) { /* storage blocked */ }
    return null;
  }
  function getFlag(type, key) {
    if (isDesignMode()) return false; // always testable in the theme editor
    var s = store(type);
    try { return !!s && s.getItem(key) === '1'; } catch (e) { return false; }
  }
  function setFlag(type, key) {
    var s = store(type);
    try { if (s) s.setItem(key, '1'); } catch (e) { /* ignore */ }
  }

  /* ---------- Dialogs (greeting + discount) ---------- */
  function isOpen(id) {
    var o = $(id);
    return !!o && o.classList.contains('is-open');
  }

  function openDialog(id, focusIds, onClose) {
    var overlay = $(id);
    if (!overlay) { if (onClose) onClose(); return; }
    if (current) closeDialog();
    current = { overlay: overlay, onClose: onClose, lastFocus: document.activeElement };
    overlay.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        // Focus once visible (hidden/visibility:hidden elements can't take focus)
        for (var i = 0; i < focusIds.length; i++) {
          var el = $(focusIds[i]);
          if (el) { el.focus({ preventScroll: true }); break; }
        }
      });
    });
    document.body.classList.add('neo-ribbon-noscroll');
    document.addEventListener('keydown', onKeydown);
  }

  function closeDialog() {
    if (!current) return;
    var d = current;
    current = null;
    d.overlay.classList.remove('is-open');
    document.body.classList.remove('neo-ribbon-noscroll');
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () {
      d.overlay.hidden = true;
      var deco = d.overlay.querySelector('.neo-ribbon-deco');
      if (deco && decoAnims[deco.id]) { decoAnims[deco.id].destroy(); delete decoAnims[deco.id]; }
    }, 300);
    if (d.lastFocus && d.lastFocus.focus && document.body.contains(d.lastFocus)) d.lastFocus.focus();
    if (d.onClose) d.onClose();
  }

  function onKeydown(e) {
    if (!current) return;
    if (e.key === 'Escape') { closeDialog(); return; }
    if (e.key !== 'Tab') return;
    // Keep keyboard focus inside the dialog
    var items = current.overlay.querySelectorAll('button, a[href], [tabindex="0"]');
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function bindDialog(id, closeIds) {
    var overlay = $(id);
    if (!overlay || overlay._neoBound) return;
    overlay._neoBound = true;
    closeIds.forEach(function (cid) { if ($(cid)) $(cid).addEventListener('click', closeDialog); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeDialog(); });
  }

  // Small ribbon drawing itself at the top of a dialog
  function playDeco(boxId, cfg) {
    var box = $(boxId);
    if (!box || !window.lottie) return;
    if (decoAnims[boxId]) { decoAnims[boxId].destroy(); delete decoAnims[boxId]; }
    fetch(cfg.animationUrl).then(function (r) { return r.json(); }).then(function (data) {
      if (cfg.color) window.PinkRibbonCatcher.recolorData(data, cfg.color);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var anim = window.lottie.loadAnimation({
        container: box, renderer: 'svg', loop: false, autoplay: false, animationData: data
      });
      anim.addEventListener('DOMLoaded', function () {
        if (reduced) { anim.goToAndStop(anim.totalFrames - 1, true); return; }
        anim.goToAndStop(0, true);
        // Start once the popup has faded in, so the draw-on is actually seen
        setTimeout(function () { if (decoAnims[boxId] === anim) anim.play(); }, 350);
      });
      decoAnims[boxId] = anim;
    }).catch(function () { /* decoration only */ });
  }

  function copyCode() {
    var code = $('neo-ribbon-code').textContent.trim();
    var done = function () {
      var btn = $('neo-ribbon-copy');
      var label = btn.textContent;
      btn.textContent = btn.getAttribute('data-copied') || 'Copied!';
      btn.classList.add('is-copied');
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-copied'); }, 2000);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
    function fallback() {
      var range = document.createRange();
      range.selectNodeContents($('neo-ribbon-code'));
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      try { if (document.execCommand('copy')) done(); } catch (e) { /* code stays selected for manual copy */ }
    }
  }

  /* ---------- Ribbon game ---------- */
  // Any visible modal dialog that isn't ours: Klaviyo sign-up forms, other apps' popups…
  function appDialogOpen() {
    var dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"], [data-kl-scroll-locking-modal]');
    for (var i = 0; i < dialogs.length; i++) {
      var d = dialogs[i];
      if (d.closest('.neo-ribbon-overlay')) continue;
      var r = d.getBoundingClientRect();
      var cs = window.getComputedStyle(d);
      if (r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') return true;
    }
    return false;
  }

  function otherPopupOpen() {
    return !!current ||
      document.body.classList.contains('modal-open') || // Bootstrap modals (newsletter, quickview, login…)
      !!document.querySelector('.modal.show') ||
      document.documentElement.classList.contains('js-drawer-open') || // mobile menu drawer
      document.body.classList.contains('js-drawer-open') ||
      appDialogOpen();
  }

  // A ribbon scrolls with the page, so it can slide under the sticky header or an open
  // mega menu. While it overlaps the header area, or the header is hovered, it steps aside.
  var yieldRaf = null;
  function updateYield() {
    yieldRaf = null;
    var ribbons = document.querySelectorAll('.pr-ribbon');
    if (!ribbons.length) return;
    var header = document.querySelector('.site-header') || document.querySelector('header');
    var hr = header ? header.getBoundingClientRect() : null;
    var menuOpen = !!(header && header.matches(':hover'));
    ribbons.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var overlaps = hr && hr.height > 0 && r.top < hr.bottom && r.bottom > hr.top && r.left < hr.right && r.right > hr.left;
      el.classList.toggle('pr-ribbon--yield', !!(overlaps || menuOpen));
    });
  }
  function scheduleYield() { if (!yieldRaf) yieldRaf = requestAnimationFrame(updateYield); }
  window.addEventListener('scroll', scheduleYield, { passive: true });
  document.addEventListener('mouseover', scheduleYield, { passive: true });

  // Greeting frequency: 'none' = every visit, 'session' = once per tab, 'forever' = once per device
  function introMemory(cfg) { return cfg.introFrequency || 'none'; }

  // '1' | '2' | 'random' (1 or 2 each time)
  function perWave(mode) {
    if (mode === '2') return 2;
    if (mode === 'random') return [1, 2];
    return 1;
  }

  // Show the greeting after `delay`, once no other popup (newsletter, menu…) is open
  var greeting = null; // { cfg, onDone, suspended }
  function showGreeting(cfg, onDone) {
    greeting = { cfg: cfg, onDone: onDone, suspended: false };
    var start = function () {
      if (otherPopupOpen()) { introTimer = setTimeout(start, 500); return; }
      introTimer = null;
      setFlag(introMemory(cfg), INTRO_KEY);
      openGreeting();
      if (window.dataLayer) window.dataLayer.push({ event: 'pink_ribbon_greeting_shown' });
    };
    introTimer = setTimeout(start, cfg.introDelay * 1000);
  }
  function openGreeting() {
    var g = greeting;
    openDialog('neo-ribbon-intro', ['neo-ribbon-intro-start', 'neo-ribbon-intro-close'], function () {
      if (g.suspended) return;        // hidden for an app popup, not dismissed
      greeting = null;
      if (g.onDone) g.onDone();
    });
    playDeco('neo-ribbon-intro-deco', g.cfg);
  }

  /* ---------- App popups opening later (Klaviyo, other apps) ---------- */
  // Our greeting steps aside and returns once the app popup is closed; ribbons on screen leave.
  var appCheckRaf = null, appPoll = null;
  function onAppPopupChange() {
    appCheckRaf = null;
    var open = appDialogOpen();
    if (open) {
      if (current && current.overlay.id === 'neo-ribbon-intro' && greeting) {
        greeting.suspended = true;
        closeDialog();
        if (!appPoll) appPoll = setInterval(onAppPopupChange, 500); // catches closes done by hiding
      }
      if (game) game.interrupt();
    } else if (greeting && greeting.suspended && !current) {
      greeting.suspended = false;
      clearInterval(appPoll); appPoll = null;
      openGreeting();
    }
  }
  function scheduleAppCheck() { if (!appCheckRaf) appCheckRaf = requestAnimationFrame(onAppPopupChange); }
  window.addEventListener('klaviyoForms', function () { setTimeout(scheduleAppCheck, 50); });
  if (window.MutationObserver) {
    new MutationObserver(scheduleAppCheck).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    destroy();
    // Leftover ribbons from a previous run (e.g. before a section reload)
    document.querySelectorAll('.pr-ribbon').forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    var cfg = readConfig();
    if (!cfg || !window.lottie || !window.PinkRibbonCatcher) return;
    bindDialog('neo-ribbon-overlay', ['neo-ribbon-close']);
    bindDialog('neo-ribbon-intro', ['neo-ribbon-intro-close', 'neo-ribbon-intro-start']);
    if ($('neo-ribbon-copy') && !$('neo-ribbon-copy')._neoBound) {
      $('neo-ribbon-copy')._neoBound = true;
      $('neo-ribbon-copy').addEventListener('click', copyCode);
    }
    // 'decor' = animation only (no click, no greeting, no popup); 'game' = catch for a discount
    var decor = cfg.mode !== 'game';
    if (!decor && getFlag(cfg.remember, STORAGE_KEY)) return; // already caught

    game = new window.PinkRibbonCatcher({
      animationPath: cfg.animationUrl,
      recolor: cfg.color || null,
      initialDelay: cfg.initialDelay * 1000,
      delayBetween: [cfg.gapMin * 1000, Math.max(cfg.gapMin, cfg.gapMax) * 1000],
      visibleDuration: cfg.visibleDuration * 1000,
      maxAppearances: cfg.unlimited ? Infinity : cfg.maxAppearances,
      maxCatches: decor ? Infinity : 1,
      decorative: decor,
      perWave: perWave(cfg.ribbonsMode),
      minDistance: 180,
      size: cfg.sizeDesktop,
      edgeMargin: 24,
      mobile: { enabled: cfg.mobile, size: cfg.sizeMobile, edgeMargin: 16, minDistance: 110 },
      reducedMotion: cfg.reducedMotion,
      strictExcludeSelectors: [
        'header', '.site-header', 'nav', '[role="dialog"]', '.modal', '[data-ribbon-exclude]',
        '#shopify-section-announcement-bar', '.js-cookie-policy', '.sticky-cart-wr',
        '.fixedBtn', '.js-back-to-top'
      ],
      canSpawn: function () { return !otherPopupOpen(); },

      onCatch: decor ? null : function (info) {
        setFlag(cfg.remember, STORAGE_KEY);
        if (window.dataLayer) window.dataLayer.push({ event: 'pink_ribbon_caught', ribbon_appearance: info.appearance });
        // Small pause so the "caught" pop animation is seen before the popup covers it
        setTimeout(function () {
          // >>> Discount popup. To use another popup instead, call it here.
          openDialog('neo-ribbon-overlay', ['neo-ribbon-copy', 'neo-ribbon-close']);
          playDeco('neo-ribbon-deco', cfg);
        }, 250);
      }
    });

    var g = game;
    // Greeting first (how often: section setting "Show greeting"); ribbons start when it's closed
    if (!decor && cfg.intro && $('neo-ribbon-intro') && !getFlag(introMemory(cfg), INTRO_KEY)) {
      showGreeting(cfg, function () { if (game === g) g.start(); });
    } else {
      g.start();
    }
  }

  function destroy() {
    clearTimeout(introTimer);
    introTimer = null;
    clearInterval(appPoll);
    appPoll = null;
    greeting = null;
    if (game) { game.destroy(); game = null; }
  }

  window.NeoPinkRibbon = { init: init, destroy: destroy };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: rebuild when the section's settings change
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('#neo-ribbon-config')) init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector('#neo-ribbon-config')) { destroy(); if (current) closeDialog(); }
  });
})();
